import Model from '@/lib/data/Model';
import FormQuestion from './FormQuestion';
import FormSection from './FormSection';
import FormData from './FormData';
import Translation from './Translation';
import RulexCDT from './RulexCDT';
import FormDataLocation from './FormDataLocation';

const FORM_URL = '/forms/form';

class Form extends Model {
    static idProperty = 'id';

    _hiddenQuestions = [];

    fields = [
        'id',
        'name',
        'order',
        'survey_info_id',
        { name: 'is_used_for_score', type: 'bool', defaultValue: false },
        'risk_weight',
        'protection_weight',
        { name: 'track_location', type: 'bool', defaultValue: false },
        'type_id',
        {
            name: 'translation',
            association: {
                type: 'one',
                model: Translation,
            },
        },
        {
            name: 'questions',
            association: {
                type: 'many',
                model: FormQuestion,
                collectionConfig: {
                    url: '/forms/form/questions',
                    method: 'GET',
                },
            },
        },
        {
            name: 'sections',
            association: {
                type: 'many',
                model: FormSection,
                collectionConfig: {
                    url: '/forms/form/sections',
                    method: 'GET',
                },
            },
        },
        {
            name: 'sectionsWithQuesControlData',
            association: {
                type: 'many',
                model: FormSection,
                collectionConfig: {
                    url: '/forms/form/sectionsWithQuesControlData',
                    method: 'GET',
                },
            },
        },
        {
            name: 'sectionsWithQues',
            association: {
                type: 'many',
                model: FormSection,
                collectionConfig: {
                    url: '/forms/form/sectionsWithQues',
                    method: 'GET',
                },
            },
        },
        {
            name: 'rulexCDTs',
            association: {
                type: 'many',
                model: RulexCDT,
                collectionConfig: {
                    url: '/form/rule/get',
                    method: 'GET',
                },
            },
        },
        {
            name: 'locations',
            association: {
                type: 'many',
                model: FormDataLocation,
            },
        },
        {
            name: 'data',
            association: {
                type: 'one',
                model: FormData,
            },
        },
        {
            name: 'visible_in_shared_mode',
            type: 'bool',
            defaultValue: true,
        },
    ];

    get questionIds() {
        let questions = [].concat(this.questions);
        const sections = [].concat(this.sections);
        const arr = [];

        sections.forEach((section) => {
            if (section.questions) {
                questions = questions.concat(section.questions);
            }
        });

        questions.forEach((question) => {
            arr.push(question.id);
        });

        return arr;
    }

    setHiddenQuestions(value, remove) {
        if (this._hiddenQuestions.indexOf(value) == -1) {
            this._hiddenQuestions.push(value);
        } else if (remove === true) {
            this._hiddenQuestions.splice(this._hiddenQuestions.indexOf(value), 1);
        }
    }

    get hiddenQuestions() {
        return this._hiddenQuestions;
    }

    /*
    get hiddenEmptyMandatoryQuestions () {
        var questions = [].concat(this.questions),
            sections = [].concat(this.sections),
            arr = [];

        sections.forEach(section => {
            if (section.questions) {
                questions = questions.concat(section.questions)
            }
        });

        questions.forEach(question => {
            if (question.mandatory && question.visible == false) {
                arr.push(question.id)
            }
        });

        return arr;
    }
*/
    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'formDetail',
            url: '/mobile/visit/form',
            params: ['id', 'survey_info_id', 'l', 'in_shared_mode', 'shared_entity_id'],
        },
        {
            name: 'formDetailUpdate',
            url: '/mobile/visit/form/save',
            params: ['id', 'survey_info_id', 'values', 'l'],
        },
        {
            name: 'create',
            url: FORM_URL,
            associated: true,
        },
        {
            name: 'update',
            url: FORM_URL,
            associated: true,
        },
        {
            name: 'destroy',
            url: FORM_URL,
            method: 'DELETE',
        },
        {
            name: 'saveQuestionsOrder',
            url: `${FORM_URL}/questions/order`,
            params: ['question_ids'],
        },
        {
            name: 'saveSectionsOrder',
            url: `${FORM_URL}/sections/order`,
            params: ['sections_ids'],
        },
        {
            name: 'saveRules',
            url: '/form/rule/save',
            associated: true,
            // params: ['rulexCDTs']
        },
    ];
}

export default Form;
